import { getPanAndZoom, getCanvasBounds } from '../viewstate';

export default function documentToPageCoordinates(documentX: number, documentY: number) {
    const { top, left } = getCanvasBounds();
    const { x, y, zoom } = getPanAndZoom();

    return {
        pageX: documentX * zoom + left + x,
        pageY: documentY * zoom + top + y,
    };
}
